// Import all function files for library registration.
import PGA from './PGA';
import trivial from './trivial';
import wikipedia from './wikipedia';

import functionLibrary from './functionLibrary';
export default functionLibrary;


// WEBPACK FOOTER //
// ./src/genetic/functions/index.js